// extracted by mini-css-extract-plugin
export default {"form":"n4Erkv","inputField":"mkMPyo","description":"G2XG6W","button":"eUVXYm","light":"O207Mf","loader":"epTFNW","compact":"eBRCdg","link":"Atdkw7"};